import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { ActionsList } from './ActionsList';
import { BlockingReasonList } from './BlockingReasonList';
import { UserDetails } from './UserDetails';
import { CheckinBlockerUser } from './_types';

export function UserContent({
  users,
  actions,
  inlineActions = false,
  showUserDetails = false,
}: {
  users: CheckinBlockerUser[];
  actions?: ButtonPropsWithLabel[];
  inlineActions?: boolean;
  showUserDetails?: boolean;
}) {
  return (
    <Stack spacing={4} sx={{ width: '100%' }}>
      {users.map((user) => (
        <Stack key={user.id} spacing={4} sx={{ width: '100%' }}>
          {showUserDetails ? (
            <UserDetails user={user} />
          ) : (
            <Typography variant="h6">{user.name}</Typography>
          )}
          <BlockingReasonList
            blockers={user.blockers}
            inlineActions={inlineActions}
            userId={user.id}
          />
        </Stack>
      ))}

      {!!actions && <ActionsList actions={actions} />}
    </Stack>
  );
}
